import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { captureTokenFromUrl } from './api/service';
import ErrorBoundary from './components/ErrorBoundary';

captureTokenFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* Last resort: catches crashes in the router/Layout chrome itself. Page-level
        crashes are caught closer to the page, inside Layout. */}
    <ErrorBoundary title="The app failed to load">
      <App />
    </ErrorBoundary>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
